import { NoBlending, ShaderMaterial, Uniform, Vector4 } from 'three'

import fragmentShaderSource from "./glsl/LiftGammaGain.frag";
import vertexShader from "./glsl/Common.vert";
import blendFunctions from "./glsl/BlendFunctions.frag";
import blendMode from "./glsl/BlendMode.frag";

/**
 * A simple copy shader material.
 */

export class LiftGammaGainMaterial extends ShaderMaterial {

    constructor() {
        let fragmentShader = fragmentShaderSource.replace("BLEND_FUNCTIONS;", blendFunctions);
        fragmentShader = fragmentShader.replace("BLEND_MODE;", blendMode);

        super({
            name: "LiftGammaGainMaterial",
            uniforms: {
                inputBuffer: new Uniform(null),
                opacity: new Uniform(1.0),
                blendID: new Uniform(0),

                lift: new Uniform(new Vector4(0, 0, 0, 0)),
                gamma: new Uniform(new Vector4(1, 1, 1, 0)),
                gain: new Uniform(new Vector4(1, 1, 1, 0)),
                offset: new Uniform(new Vector4(0, 0, 0, 0)),

                exposure: new Uniform(0),
                contrast: new Uniform(0),
                pivot: new Uniform(0.435),
                clampSetting: new Uniform(1),
            },
            blending: NoBlending,
            depthWrite: false,
            depthTest: false,
            fragmentShader,
            vertexShader
        });
    }


    /**
     * The input buffer.
     *
     * @type {Texture}
     */

    set inputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Number} value - The buffer.
     */

    setInputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Returns the opacity.
     *
     * @deprecated Use opacity instead.
     * @return {Number} The opacity.
     */

    getOpacity(value) {

        return this.uniforms.opacity.value;

    }

    /**
     * Sets the opacity.
     *
     * @deprecated Use opacity instead.
     * @param {Number} value - The opacity.
     */

    setOpacity(value) {

        this.uniforms.opacity.value = value;

    }

}
